import { Component, OnInit, OnDestroy } from "@angular/core";
import { EmailsService } from "../services/emails.service";
const alertify = require("alertify.js");
import { Title } from '@angular/platform-browser';

@Component({
  selector: "ch-emails-listing",
  templateUrl: "./emails-listing.component.html",
  styleUrls: ["./emails-listing.component.css"],
})
export class EmailsListingComponent implements OnInit, OnDestroy {
  public loading: boolean;
  public items = [];
  public selectedItem;

  constructor(private emailsService: EmailsService, private titleService: Title) {
    alertify.logPosition("bottom right");
  }

  ngOnInit() {
    this.titleService.setTitle(`Emails | CODE Hospitality CMS`);
    this.getAllEmails();
  }

  ngOnDestroy(): void {
    this.titleService.setTitle(`CODE Hospitality CMS`);
  }

  private getAllEmails() {
    this.loading = true;

    this.emailsService.getAllEmails().subscribe(
      data => {
        this.items = data.json();
        this.selectItem(0);
      },
      error => {
        alertify.error(error);
      }
    );

    this.loading = false;
  }

  public selectItem(index: number) {
    if (this.items.length > index) {
      this.selectedItem = this.items[index];
    }
  }
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/emails/emails-listing/emails-listing.component.ts